import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { theme } from 'theme'

const CoreProgressLabelWrapper = styled(Box)<{ percent: number }>`
  ${(props) => `
  position: absolute;
  top: -37px;
  left: ${props.percent}%;
  `}
`

const PointerWrapper = styled(Box)`
  position: absolute;
  transform: translate(-50%, 9px);
  z-index: 10;
  color: ${theme.palette.primary.main};
`

const LabelWrapper = styled(Box)`
  position: absolute;
  transform: translate(-101%, 4px);
`

type Props = {
  label: string
  percent: number
}

export const CoreProgressLabel = (props: Props) => {
  const { label, percent } = props

  return (
    <CoreProgressLabelWrapper
      component="span"
      percent={percent}
      sx={{ color: '#666666' }}
    >
      <PointerWrapper fontSize={12} fontWeight={600}>
        |
      </PointerWrapper>
      <LabelWrapper>
        <Typography variant="overline" whiteSpace="nowrap">
          {label}
        </Typography>
      </LabelWrapper>
    </CoreProgressLabelWrapper>
  )
}
